var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCasesBlack24Dp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cases_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6785",
    "data-name": "Group 6785"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1018",
    "data-name": "Rectangle 1018",
    width: 20,
    height: 20,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6787",
    "data-name": "Group 6787",
    transform: "translate(0.851 0.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6786",
    "data-name": "Group 6786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M2.7,9H1v9.364a1.7,1.7,0,0,0,1.7,1.7H17.175v-1.7H2.7Z",
    transform: "translate(-1 -2.19)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M16.067,4.405V2.7a1.708,1.708,0,0,0-1.7-1.7H10.959a1.708,1.708,0,0,0-1.7,1.7v1.7H5v9.364a1.708,1.708,0,0,0,1.7,1.7H18.621a1.708,1.708,0,0,0,1.7-1.7V4.405ZM10.959,2.7h3.405v1.7H10.959Zm7.662,11.067H6.7V6.108H18.621Z",
    transform: "translate(-1.595 -1)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasesBlack24Dp);
export default __webpack_public_path__ + "static/media/cases_black_24dp.35346bb30521821e0f4a82ebd6e5c620.svg";
export { ForwardRef as ReactComponent };